var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCabinetFiling = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V19.5C24 21.1569 22.6569 22.5 21 22.5H3C1.34315 22.5 0 21.1569 0 19.5V3ZM1.5 3C1.5 2.17157 2.17157 1.5 3 1.5H21C21.8284 1.5 22.5 2.17157 22.5 3V10.5H1.5V3ZM22.5 12H1.5V19.5C1.5 20.3284 2.17157 21 3 21H21C21.8284 21 22.5 20.3284 22.5 19.5V12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.25C18 4.83579 17.6642 4.5 17.25 4.5H6.75C6.33579 4.5 6 4.83579 6 5.25V6.75C6 7.16421 6.33579 7.5 6.75 7.5C7.16421 7.5 7.5 7.16421 7.5 6.75V6H16.5V6.75C16.5 7.16421 16.8358 7.5 17.25 7.5C17.6642 7.5 18 7.16421 18 6.75V5.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15.75C18 15.3358 17.6642 15 17.25 15H6.75C6.33579 15 6 15.3358 6 15.75V17.25C6 17.6642 6.33579 18 6.75 18C7.16421 18 7.5 17.6642 7.5 17.25V16.5H16.5V17.25C16.5 17.6642 16.8358 18 17.25 18C17.6642 18 18 17.6642 18 17.25V15.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCabinetFiling);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cabinet-filing.8175e3220646a41620071f90eab1f88b.svg";